export default __webpack_public_path__ + "static/media/team.7152abd5.svg";